import { cardSrc } from './resultParsers';

export default function Race17Result({ detail }) {
  // A round won before the 5th card leaves the rest undealt ("1", e.g. "4SS,3HH,3SS,8DD,1");
  // show only dealt cards, no face-down card (user 2026-10-19).
  const allCards = (detail?.card || '').split(',').map((s) => s.trim()).filter((c) => c && c !== '1' && c !== '0');
  const parts = (detail?.rdesc || '').split('#');
  const raceTo17 = parts[0] || '';
  const bigCard = parts[1] || '';
  const zeroCard = parts[2] || '';
  const oneZero = parts[3] || '';

  return (
    <div className="row row5 worli-result">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center w-100">
            <div className="casino-result-cards">
              {allCards.map((code, i) => (
                <div key={i} className="casino-result-cards-item mr-1">
                  <img src={cardSrc(code)} alt={code} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Race to 17</div>
            <div>{raceTo17}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Big Card</div>
            <div>{bigCard}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Zero Card</div>
            <div>{zeroCard}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>One Zero Card</div>
            <div>{oneZero}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
